// extracted by mini-css-extract-plugin
export default {"title":"auth_title__yJfQ9","wrapper":"auth_wrapper__N+PRe","formDiv":"auth_formDiv__F6lcj","additionals":"auth_additionals__T37Xj"};